import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { StyleService } from '@src/style/service'
import { sensorSelector } from '@src/selectors/sensor'
import { InlineAlert } from '@src/components/InlineAlert'
import { MONTH_NAME_AND_DATE_FORMAT } from '@src/config/momentFormat'
import { SensorStatus, UiInlineAlert } from '@src/types'

export const ExpiringSensorPopup = () => {
  const sensor = useSelector(sensorSelector)

  // We don't want to show this popup for expired sensors
  // Check for case of sensor expirationTime not existing when upgrading from old app versions
  if (!sensor || !sensor.expirationTime || sensor.status === SensorStatus.Expired) {
    return null
  }

  const sensorExpirationTime = moment(sensor.expirationTime)

  const hoursRemaining = sensorExpirationTime.diff(moment(), 'hours')

  if (hoursRemaining >= 12) {
    return null
  }

  const expirationTime = sensorExpirationTime.format(MONTH_NAME_AND_DATE_FORMAT)

  if (hoursRemaining >= 0) {
    return (
      <InlineAlert
        style={styles.popup}
        category={UiInlineAlert.Warning}
        message={`Your sensor expires ${expirationTime}`}
      />
    )
  }

  const popupText = 'Your current sensor expired. Please start a new sensor'

  return <InlineAlert style={styles.popup} category={UiInlineAlert.Danger} message={popupText} />
}

const styles = StyleService.create({
  popup: {
    marginHorizontal: 16,
    marginTop: 8,
  },
})
